import moment from 'moment-timezone';
import contacts from '@/api/contacts';
import statisticApi from '@/api/statistic';
import tagApi from '@/api/tag';
import productApi from '@/api/products';
import { formatDate, groupBy } from '../../lib/helper';
import { customerMapChartOptions } from '../../lib/options/chart-options';

const SET_CONTACTS = 'SET_CONTACTS';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const CLEAR_CONTACTS = 'CLEAR_CONTACTS';
const RESET_CONTACTS = 'RESET_CONTACTS';
const EDIT_CONTACT = 'EDIT_CONTACT';
const DELETE_CONTACT = 'DELETE_CONTACT';
const APPEND_CONTACTS = 'APPEND_CONTACTS';
const APPEND_NEW_CONTACT = 'APPEND_NEW_CONTACT';
const SET_PAGE = 'SET_PAGE';
const ADD_PAGE = 'ADD_PAGE';
const SET_IS_ALL = 'SET_IS_ALL';
const SET_CONTACT_DETAIL = 'SET_CONTACT_DETAIL';
const UPDATED_CONTACT_TAG = 'UPDATED_CONTACT_TAG';
const UPDATED_CONTACTS_TAG = 'UPDATED_CONTACTS_TAG';
const UPDATED_CONTACT_DATA = 'UPDATED_CONTACT_DATA';

// REMINDER
const SET_CONTACTS_REMINDER = 'SET_CONTACTS_REMINDER';
const SET_IS_FETCHING_REMINDER = 'SET_IS_FETCHING_REMINDER';
const CLEAR_CONTACTS_REMINDER = 'CLEAR_CONTACTS_REMINDER';
const RESET_CONTACTS_REMINDER = 'RESET_CONTACTS_REMINDER';
// const EDIT_CONTACT_REMINDER = 'EDIT_CONTACT_REMINDER';
const DELETE_CONTACT_REMINDER = 'DELETE_CONTACT_REMINDER';
const DELETE_CONTACT_REMINDERS = 'DELETE_CONTACT_REMINDERS';
const APPEND_CONTACTS_REMINDER = 'APPEND_CONTACTS_REMINDER';
const SET_PAGE_REMINDER = 'SET_PAGE_REMINDER';
const ADD_PAGE_REMINDER = 'ADD_PAGE_REMINDER';
const SET_IS_ALL_REMINDER = 'SET_IS_ALL_REMINDER';
const APPEND_COUNT_CONTACTS_REMINDER = 'APPEND_COUNT_CONTACTS_REMINDER';

// activity
const SET_ACTIVITIES = 'SET_ACTIVITIES';
const APPEND_ACTIVITIES = 'APPEND_ACTIVITIES';
const CLEAR_ACTIVITIES = 'CLEAR_ACTIVITIES';
const RESET_ACTIVITIES = 'RESET_ACTIVITIES';
const SET_ACTIVITIES_PAGE = 'SET_ACTIVITIES_PAGE';
const ADD_ACTIVITIES_PAGE = 'ADD_ACTIVITIES_PAGE';
const SET_ACTIVITIES_IS_ALL = 'SET_ACTIVITIES_IS_ALL';
const SET_ACTIVITIES_FETCHING = 'SET_ACTIVITIES_FETCHING';
const APPEND_NEW_ACTIVITY = 'APPEND_NEW_ACTIVITY';

// statistic
const SET_CONTACT_STAT = 'SET_CONTACT_STAT';
const SET_CONTACT_REGION_STAT = 'SET_CONTACT_REGION_STAT';

// tag
const SET_TAGS = 'SET_TAGS';
const APPEND_TAGS = 'APPEND_TAGS';

// product
const SET_PRODUCTS = 'SET_PRODUCTS';
const SET_IS_FETCHING_PRODUCTS = 'SET_IS_FETCHING_PRODUCTS';

const state = {
	all: [],
	isFetching: false,
	isFetched: false,
	isAll: false,
	page: 1,
	detail: '',
	activitiesFetching: false,
	activitiesAll: [],
	activitiesIsAll: false,
	activitiesPage: 1,
	contactStat: {},
	contactRegionStat: {},
	remindersAll: [],
	isFetchingReminder: false,
	isReminderAll: false,
	pageReminder: 1,
	totalContactReminders: 0,
	tags: [],
	products: [],
};

const getters = {
	all: state => state.all,
	isFetching: state => state.isFetching,
	isFetched: state => state.isFetched,
	isAll: state => state.isAll,
	page: state => state.page,
	detail: state => state.detail,
	activitiesFetching: state => state.activitiesFetching,
	activitiesAll: state => state.activitiesAll,
	activitiesIsAll: state => state.activitiesIsAll,
	activitiesPage: state => state.activitiesPage,
	contactStat: state => state.contactStat,
	contactRegionStat: state => state.contactRegionStat,
	remindersAll: state => state.remindersAll,
	isFetchingReminder: state => state.isFetchingReminder,
	isReminderAll: state => state.isReminderAll,
	pageReminder: state => state.pageReminder,
	totalContactReminders: state => state.totalContactReminders,
	tags: state => state.tags,
	products: state => state.products,
};

const mutations = {
	[SET_CONTACTS](state, contacts) {
		state.all = contacts;
	},
	[APPEND_CONTACTS](state, contacts) {
		state.all = state.all.concat(contacts);
	},
	[APPEND_NEW_CONTACT](state, contact) {
		const contacts = state.all;
		contacts.unshift(contact);
		state.all = contacts;
	},
	[CLEAR_CONTACTS](state) {
		state.all = [];
	},
	[RESET_CONTACTS](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[DELETE_CONTACT](state, index) {
		state.all.splice(index, 1);
	},
	[SET_PAGE](state, page) {
		state.page = page;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[SET_IS_ALL](state, isAll) {
		state.isAll = isAll;
	},
	[EDIT_CONTACT](state, contact) {
		const index = state.all.findIndex(currContact => currContact._id === contact._id);
		if (index !== -1) {
			state.all[index] = contact;
		}
	},
	[SET_CONTACT_DETAIL](state, contact) {
		state.detail = contact;
	},
	[UPDATED_CONTACT_TAG](state, contact) {
		const contactIndex = state.all.findIndex(curr => curr._id === contact._id);
		if (contactIndex !== -1) {
			state.all[contactIndex].tags = contact.tags;
		}
	},
	[UPDATED_CONTACT_DATA](state, contact) {
		const contactIndex = state.all.findIndex(curr => curr._id === contact._id);
		if (contactIndex !== -1) {
			state.all[contactIndex].name = contact.name;
			state.all[contactIndex].phone = contact.phone;
			state.all[contactIndex].email = contact.email;
			state.all[contactIndex].tags = contact.tags;
			state.all[contactIndex].picture = contact.picture;
		}
	},
	[UPDATED_CONTACTS_TAG](state, data) {
		const ids = data.ids;
		const tags = data.tags;
		for (let index = 0; index < ids.length; index++) {
			const id = ids[index];
			const contactIndex = state.all.findIndex(curr => curr._id === id);
			if (contactIndex !== -1) {
				state.all[contactIndex].tags = tags;
			}
		}
	},

	// activity
	[SET_ACTIVITIES_FETCHING](state, value) {
		state.activitiesFetching = value;
	},
	[SET_ACTIVITIES](state, data) {
		state.activitiesAll = data;
	},
	// eslint-disable-next-line
	[APPEND_ACTIVITIES](state, activities) {
		const looper = (activityGroup) => {
			const oldActivityGroupIndex = state.activitiesAll.findIndex(oldActivity => oldActivity.date === activityGroup.date);
			if (oldActivityGroupIndex !== -1) {
				const oldActivityGroup = state.activitiesAll[oldActivityGroupIndex];
				const newActivities = activityGroup.data;
				// const newActivitiesReversed = newActivities.reverse();
				const newData = oldActivityGroup.data.concat(newActivities);
				state.activitiesAll[oldActivityGroupIndex].data = newData;
			} else {
				// state.activitiesAll.push(activityGroup);
				// activityGroup.data = activityGroup.data.reverse();
				state.activitiesAll = [...state.activitiesAll, activityGroup];
			}
		};
		activities.forEach(looper);
	},
	[CLEAR_ACTIVITIES](state) {
		state.activitiesAll = [];
	},
	[RESET_ACTIVITIES](state) {
		state.activitiesAll = [];
		state.activitiesIsAll = false;
		state.activitiesPage = 1;
	},
	[SET_ACTIVITIES_PAGE](state, page) {
		state.activitiesPage = page;
	},
	[ADD_ACTIVITIES_PAGE](state) {
		state.activitiesPage++;
	},
	[SET_ACTIVITIES_IS_ALL](state, isAll) {
		state.activitiesIsAll = isAll;
	},
	[APPEND_NEW_ACTIVITY](state, activity) {
		const oldActivityGroupIndex = state.activitiesAll.findIndex(oldActivity => oldActivity.date === activity.date);
		if (oldActivityGroupIndex !== -1) {
			const oldActivityGroup = state.activitiesAll[oldActivityGroupIndex];
			const newActivities = activity.data;
			const newData = newActivities.concat(oldActivityGroup.data);
			state.activitiesAll[oldActivityGroupIndex].data = newData;
		} else {
			state.activitiesAll.unshift(activity);
		}
	},

	// statistic
	[SET_CONTACT_STAT](state, value) {
		state.contactStat = value;
	},
	[SET_CONTACT_REGION_STAT](state, value) {
		state.contactRegionStat = value;
	},

	// reminder
	[SET_CONTACTS_REMINDER](state, value) {
		state.remindersAll = value;
	},
	[APPEND_CONTACTS_REMINDER](state, value) {
		state.remindersAll = state.remindersAll.concat(value);
	},
	[APPEND_COUNT_CONTACTS_REMINDER](state, value) {
		state.totalContactReminders = value;
	},
	[CLEAR_CONTACTS_REMINDER](state) {
		state.remindersAll = [];
	},
	[RESET_CONTACTS_REMINDER](state) {
		state.remindersAll = [];
		state.isReminderAll = false;
		state.pageReminder = 1;
	},
	[SET_IS_FETCHING_REMINDER](state, status) {
		state.isFetchingReminder = status;
	},
	[DELETE_CONTACT_REMINDER](state, index) {
		state.remindersAll.splice(index, 1);
	},
	[DELETE_CONTACT_REMINDERS](state, ids) {
		for (let i = 0; i < ids.length; i++) {
			const id = ids[i];
			const index = state.remindersAll.findIndex(reminder => reminder.activity_id.$oid === id);
			if (index !== -1) {
				state.remindersAll.splice(index, 1);
			}
		}
	},
	[SET_PAGE_REMINDER](state, pageReminder) {
		state.pageReminder = pageReminder;
	},
	[ADD_PAGE_REMINDER](state) {
		state.pageReminder++;
	},
	[SET_IS_ALL_REMINDER](state, isAll) {
		state.isReminderAll = isAll;
	},

	// tgs
	[SET_TAGS](state, tags) {
		state.tags = tags;
	},
	[APPEND_TAGS](state, tags) {
		state.tags = state.tags.concat(tags);
	},

	// product
	[SET_IS_FETCHING_PRODUCTS](state, value) {
		state.isFetchingProducts = value;
	},
	[SET_PRODUCTS](state, products) {
		state.products = products;
	},
};

const actions = {
	// cutomers
	getContacts({ commit, getters }, params) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const contacts = response.data;

				if (getters.all.length === 0) {
					commit(SET_CONTACTS, contacts);
				} else if (contacts.length !== 0) {
					commit(APPEND_CONTACTS, contacts);
				}

				if (contacts.length === 0) {
					commit(SET_IS_ALL, true);
				} else {
					commit(SET_IS_ALL, false);
				}

				commit(ADD_PAGE);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_ALL, true);
				commit(SET_IS_FETCHED, true);
			};
			contacts.getContacts(params, callback, errorCallback);
		}
	},
	getDetailContact({ commit }, params) {
		commit(SET_IS_FETCHING, true);
		const callback = (response) => {
			const contacts = response.data;
			commit(SET_CONTACT_DETAIL, contacts);
			commit(SET_IS_FETCHING, false);
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			commit(SET_IS_FETCHING, false);
		};
		contacts.getDetails(params, callback, errorCallback);
	},
	delete({ commit }, index) {
		commit(DELETE_CONTACT, index);
	},
	setPage({ commit }, value) {
		commit(SET_PAGE, value);
	},
	setIsAll({ commit }, isAll) {
		commit(SET_IS_ALL, isAll);
	},
	clearContacts({ commit }) {
		commit(CLEAR_CONTACTS);
	},
	resetContacts({ commit }) {
		commit(RESET_CONTACTS);
	},
	updateContact({ commit }, contact) {
		commit(EDIT_CONTACT, contact);
	},
	setAppendContact({ commit }, value) {
		commit(SET_CONTACTS, value);
	},
	setAppendNewContact({ commit }, value) {
		commit(APPEND_NEW_CONTACT, value);
	},
	updatedContactTag({ commit }, value) {
		commit(UPDATED_CONTACT_TAG, value);
	},
	updatedContactsTag({ commit }, value) {
		commit(UPDATED_CONTACTS_TAG, value);
	},
	updatedContactData({ commit }, value) {
		commit(UPDATED_CONTACT_DATA, value);
	},

	// activities
	getContactActivities({ commit, getters }, params) {
		if (!getters.activitiesFetching) {
			commit(SET_ACTIVITIES_FETCHING, true);
			const callback = (response) => {
				const activities = response.data;

				const formattedActivities = activities.map((el) => {
					el.date = formatDate(moment, el.activity_date);
					return el;
				});
				const groupedActivities = groupBy(formattedActivities, 'date');

				// eslint-disable-next-line
				const groupArrayActivities = Object.keys(groupedActivities).map((el) => {
					return {
						date: el,
						data: groupedActivities[el],
					};
				});

				// sort by date
				const groupActivitiesSort = groupArrayActivities.sort((a, b) => {
					const c = new Date(a.date);
					const d = new Date(b.date);
					return d - c;
				});

				// eslint-disable-next-line
				// console.log('das', groupActivitiesSort);

				if (activities.length !== 0) {
					commit(APPEND_ACTIVITIES, groupActivitiesSort);
					commit(ADD_ACTIVITIES_PAGE);
				} else {
					commit(SET_ACTIVITIES_IS_ALL, true);
				}
				commit(SET_ACTIVITIES_FETCHING, false);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_ACTIVITIES_FETCHING, false);
				commit(SET_ACTIVITIES_IS_ALL, true);
			};
			contacts.getActivities(params, callback, errorCallback);
		}
	},
	setActivitiesPage({ commit }, value) {
		commit(SET_ACTIVITIES_PAGE, value);
	},
	setActivitiesIsAll({ commit }, isAll) {
		commit(SET_ACTIVITIES_IS_ALL, isAll);
	},
	clearActivities({ commit }) {
		commit(CLEAR_ACTIVITIES);
	},
	resetActivities({ commit }) {
		commit(RESET_ACTIVITIES);
	},
	setNewActivity({ commit }, value) {
		const newValue = value;
		newValue.date = formatDate(moment, value.activity_date);
		const newData = {
			date: newValue.date,
			data: [newValue],
		};

		commit(APPEND_NEW_ACTIVITY, newData);
	},

	// statistic
	getStatistic({ commit }, params) {
		commit(SET_IS_FETCHING, true);
		const callback = (response) => {
			const contacts = response.data;
			commit(SET_CONTACT_STAT, contacts);
			commit(SET_IS_FETCHING, false);
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			commit(SET_IS_FETCHING, false);
		};
		statisticApi.getContactStats(params, callback, errorCallback);
	},
	getRegionStatistic({ commit }, params) {
		commit(SET_IS_FETCHING, true);
		const callback = (response) => {
			const contacts = response.data;
			const stat = customerMapChartOptions(contacts);

			commit(SET_CONTACT_REGION_STAT, stat);
			commit(SET_IS_FETCHING, false);
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			commit(SET_IS_FETCHING, false);
		};
		statisticApi.getContactRegionStats(params, callback, errorCallback);
	},

	// reminder
	getContactsReminder({ commit, getters }, params) {
		if (!getters.isFetchingReminder) {
			commit(SET_IS_FETCHING_REMINDER, true);
			const callback = (response) => {
				const reminders = response.data.customers || [];
				const remindersFormatted = reminders.map((el) => {
					if (el.last_contacted) {
						const dd = el.last_contacted.$date.$numberLong;
						const newDd = dd.slice(0, -3);
						// Convert timestamp to milliseconds
						const date = new Date(parseInt(newDd) * 1000);
						el.formated_last_contacted = date;
					} else {
						el.formated_last_contacted = '';
					}
					return el;
				});

				commit(ADD_PAGE_REMINDER);

				if (remindersFormatted.length > 0) {
					commit(APPEND_CONTACTS_REMINDER, remindersFormatted);
				}

				if (remindersFormatted.length < params.limit) {
					commit(SET_IS_ALL_REMINDER, true);
				}

				commit(SET_IS_FETCHING_REMINDER, false);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING_REMINDER, false);
				commit(SET_IS_ALL_REMINDER, true);
			};
			contacts.getContacts(params, callback, errorCallback);
		}
	},
	getContactCountsReminder({ commit }, params) {
		const callback = (response) => {
			const data = response.data;
			const reminders = (data.page_info) ? data.page_info.total_all_customers : [];
			if (reminders.length !== 0) {
				commit(APPEND_COUNT_CONTACTS_REMINDER, reminders);
			}
			commit(SET_IS_FETCHING_REMINDER, false);
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			commit(SET_IS_FETCHING_REMINDER, false);
		};
		contacts.getContacts(params, callback, errorCallback);
	},
	deleteReminder({ commit }, index) {
		commit(DELETE_CONTACT_REMINDER, index);
	},
	deleteReminders({ commit }, ids) {
		commit(DELETE_CONTACT_REMINDERS, ids);
	},
	setPageReminder({ commit }, value) {
		commit(SET_PAGE_REMINDER, value);
	},
	setIsAllReminder({ commit }, isAll) {
		commit(SET_IS_ALL_REMINDER, isAll);
	},
	clearContactsReminder({ commit }) {
		commit(CLEAR_CONTACTS_REMINDER);
	},
	resetContactsReminder({ commit }) {
		commit(RESET_CONTACTS_REMINDER);
	},

	// tags
	getContactTags({ commit }, params) {
		const callback = (response) => {
			const tags = response.data;
			if (tags.length !== 0) {
				commit(SET_TAGS, tags);
			}
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
		};
		tagApi.getTags(params, callback, errorCallback);
	},
	setAppendTag({ commit }, value) {
		commit(APPEND_TAGS, value);
	},

	// product
	// get product
	getProducts({ commit, getters }) {
		if (!getters.isFetchingProducts) {
			commit(SET_IS_FETCHING_PRODUCTS, true);
			const callback = (response) => {
				const products = response.data;
				commit(SET_PRODUCTS, products);
				commit(SET_IS_FETCHING_PRODUCTS, false);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING_PRODUCTS, false);
			};
			// products.getProductsList(callback, errorCallback);
			productApi.getProductsList(callback, errorCallback);
		}
	},

};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
